import React from 'react'
import {withStyles} from 'material-ui/styles'
import {Footer, TopBar} from './components'
import promoList from './promos.json'

const styles = theme => ({
  wrapper: {
    width: '100%',
    height: '100%',
  },
  container: {
    width: '98%',
    height: '100%',
    margin: '70px auto',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
  },
  bigImage: {
    width: 200,
    height: 200,
    float: 'left',
    backgroundSize: '100%',
    '&:nth-child(3)': {
      margin: '0 0 0 100px',
    },
    [theme.breakpoints.down('xs')]: {
      '&:nth-child(3)': {
        display: 'none',
      },
    },
  },
  smallImage: {
    width: 80,
    height: 80,
    position: 'absolute',
    top: 0,
    left: 0,
    margin: '125px 0 0 207px',
    backgroundColor: '#FFF',
    backgroundSize: '100%',
    borderRadius: 10,
    border: '5px solid #FFF',
  },
  promo: {
    width: 500,
    height: 235,
    float: 'left',
    position: 'relative',
    backgroundColor: '#111',
    background: 'linear-gradient(to bottom, #606360 0%,#212121 50%,#000000 51%,#262626 100%)',
    padding: 10,
    margin: 5,
    borderRadius: 10,
    border: '1px solid #FFF',
  },
  title: {
    width: '100%',
    height: 20,
    lineHeight: '20px',
    margin: '0 0 10px 0',
    float: 'left',
    color: '#FFF',
    borderBottom: '1px dotted #999',
  },
})

const host = window.location.host
const domain = host.split('.')[1]
const subDomain = host.split('.')[0]

const Promos = ({classes}) => promoList.map(x => {
  const isHumpDayPromo = x.name === 'Hump Day'

  return (
  <div key={x.id} className={classes.promo} style={{borderColor: isHumpDayPromo && '#d1ad42'}}>
    <div className={classes.title} style={{color: isHumpDayPromo && '#d1ad42'}}>{x.id} - {x.name}</div>
    <img className={classes.bigImage} alt={x.id} src={`//cdn.clickbit.net/promos/promo${x.id}a.png`}/>
    <img className={classes.bigImage} alt={x.id} src={`//cdn.clickbit.net/promos/promo${x.id}b.png`}/>
    <img className={classes.smallImage} alt={x.id} src={`//cdn.clickbit.net/promos/promo${x.id}c.gif`}/>
  </div>)
})

const App = ({classes}) =>
  <div className={classes.wrapper}>
    <TopBar name={`${domain} ${subDomain}`}/>
    <div className={classes.container}>
      <Promos classes={classes}/>
    </div>
    <Footer name={subDomain}/>
  </div>

export default withStyles(styles, {withTheme: true})(App)



// WEBPACK FOOTER //
// ./src/App.js